import React from 'react';

import ReviewProvider from 'parent-portal/provider-reviews/ReviewProvider';
import { Modal } from 'library/ui';

export type PromptType = 'block' | 'prefer';

export function PromptForReviewModal({
    open,
    onClose,
    userId,
    promptedByActionType,
}: {
    open: boolean;
    onClose: () => void;
    userId?: number;
    promptedByActionType?: PromptType;
}) {
    if (!open) return null;
    return (
        <Modal onClose={onClose}>
            <ReviewProvider promptedByActionType={promptedByActionType} userId={userId} />
        </Modal>
    );
}
